import React, { useState, useEffect } from "react";
import PreviewBar from "../../Components/PreviewBar/PreviewBar";
import Button from "../../Components/Button/Button";
import InputBox from "../../Components/InputBox/InputBox";
import "./Procedure.css";
import {
  EditIcon,
  RadioBoxActiveIcon,
  RadioBoxInActiveIcon
} from "../../Assets/assets";
import { defaultProcedureStep } from "../../Utils/Constants/Procedures";
import {
  SelectionCard,
  SelectionRadioCard
} from "../../Components/Cards/Cards";
import { useParams } from "react-router-dom";
import { isValidObject } from "../../Services/validators";
import TrackProgress from "../../Components/TrackProgress/TrackProgress";

export default function CreateProcedure(props) {
  const { procedureId } = useParams();
  const [step, setStep] = useState("selection");
  const [procedure, setProcedure] = useState({
    title: "",
    type: ""
  });
  const [procedureSteps, setProcedureSteps] = useState([defaultProcedureStep]);
  const [editProcedureStepIndex, setEditProcedureStepIndex] = useState(
    procedureSteps.length - 1
  );

  function isValidProcedureStep(data) {
    if (data.title?.length > 1 && data.description.length > 1) {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    if (editProcedureStepIndex !== null) {
      const element = document.getElementById(
        `procedureStep${editProcedureStepIndex}`
      );
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "end"
        });
      }
    }
  }, [editProcedureStepIndex]);

  useEffect(() => {
    if (procedureId && isValidObject(props.selectedProcedure)) {
      setProcedure({
        title: props.selectedProcedure.title,
        type: props.selectedProcedure.procedureType
      });
      setProcedureSteps(props.selectedProcedure.steps);
      setStep(props.selectedProcedure.procedureType ? "creation" : "selection");
      setEditProcedureStepIndex(null);
    }
    // eslint-disable-next-line
  }, [procedureId, props.selectedProcedure]);

  return (
    <PreviewBar
      title={procedureId ? "EDIT PROCEDURE" : "NEW PROCEDURE"}
      onCloseClick={() => {
        if (procedureId) {
          props.headerTextButtonOnClick();
        } else {
          props.navigate("/procedures");
        }
      }}
    >
      <div className="inherit-parent-height font-size-medium display-flex flex-direction-column flex-justify-content-space-between ">
        {step === "selection" && (
          <>
            <div>
              <div className="padding-bottom-default font-color-tertiaryColor6">
                TYPE
              </div>
              {[
                {
                  title: "EMPLOYEE",
                  description:
                    "Create a procedure for tracking employee tasks and logistics at specified intervals."
                },
                {
                  title: "SENSOR",
                  description:
                    "Create a procedure for sensors to track readings, measurements, and other metrics at specified intervals."
                }
              ].map((data, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setProcedure({ ...procedure, type: data.title });
                  }}
                  className="padding-bottom-large"
                >
                  <SelectionRadioCard
                    data={data}
                    selected={procedure.type === data.title}
                  />
                </div>
              ))}
            </div>
            <Button
              text="Continue"
              data-cy="CONFIRM-PROCEDURE-TYPE-BUTTON"
              disabled={procedure.type ? false : true}
              onClick={() => {
                setStep("creation");
              }}
              className="inherit-parent-width"
            />
          </>
        )}

        {step === "creation" && (
          <div className="inherit-parent-height display-flex flex-justify-content-space-between flex-direction-column overflow-hidden">
            <div
              style={{
                height: "calc(100% - 56px)"
              }}
              className="overflow-scroll"
            >
              <SelectionCard
                title="TYPE"
                value={procedure.type}
                changeOnClick={() => {
                  setStep("selection");
                }}
              />

              <InputBox
                className="inherit-parent-width padding-top-larger"
                name="procedureTitle"
                label="TITLE"
                placeholder="Enter Procedure Title"
                type="text"
                removeResponsive={true}
                autoComplete="off"
                value={procedure.title}
                fontColor="font-color-tertiaryColor"
                labelFontColor="font-color-tertiaryColor"
                onChange={(event) => {
                  setProcedure({ ...procedure, title: event.target.value });
                }}
                data-cy="TITLE-FIELD"
                required
              />
              <div
                className="overflow-scroll"
                style={{ height: "calc(100% - 131px)" }}
              >
                {procedureSteps?.map((data, index) => (
                  <React.Fragment key={index}>
                    <TrackProgress
                      title={`Step ${index + 1}`}
                      state={
                        editProcedureStepIndex === index ? "ACTIVE" : "INACTIVE"
                      }
                      data={
                        <ProcedureStep
                          data={data}
                          procedureStepId={`procedureStep${index}`}
                          editProcedure={editProcedureStepIndex === index}
                          editOnClick={() => {
                            setEditProcedureStepIndex(index);
                          }}
                          formOnChange={(event) => {
                            setProcedureSteps((prevSteps) =>
                              prevSteps.map((step, stepIndex) =>
                                stepIndex === index
                                  ? {
                                      ...step,
                                      [event.target.name]: event.target.value
                                    }
                                  : step
                              )
                            );
                          }}
                          isProofRequiredOnChange={(bool) => {
                            setProcedureSteps((prevSteps) =>
                              prevSteps.map((step, stepIndex) =>
                                stepIndex === index
                                  ? {
                                      ...step,
                                      isProofRequired: bool
                                    }
                                  : step
                              )
                            );
                          }}
                          disableStepEditButton={
                            editProcedureStepIndex !== null
                          }
                          disableSaveButton={
                            !isValidProcedureStep(procedureSteps[index])
                          }
                          saveStepOnClick={() => {
                            setEditProcedureStepIndex(null);
                          }}
                          disableDeleteButton={procedureSteps.length === 1}
                          deleteStepOnClick={() => {
                            setProcedureSteps((prevSteps) =>
                              prevSteps.filter(
                                (_, stepIndex) => index !== stepIndex
                              )
                            );
                            setEditProcedureStepIndex(null);
                          }}
                        />
                      }
                    />
                  </React.Fragment>
                ))}
              </div>
            </div>

            {editProcedureStepIndex === null && (
              <div>
                <Button
                  variant="transparent"
                  text="Add step"
                  data-cy="ADD-PROCEDURE-STEP"
                  boxShadow={false}
                  // disabled={true}
                  onClick={() => {
                    const currentTotalStep = procedureSteps.length - 1;
                    setProcedureSteps([
                      ...procedureSteps,
                      defaultProcedureStep
                    ]);
                    setEditProcedureStepIndex(currentTotalStep + 1);
                  }}
                  className="inherit-parent-width margin-bottom-medium margin-top-medium"
                />
                <Button
                  text={procedureId ? "Save changes" : "Create procedure"}
                  data-cy={
                    procedureId
                      ? "SAVE-CHANGES-PROCEDURE-BUTTON"
                      : "CREATE-PROCEDURE-BUTTON"
                  }
                  boxShadow={false}
                  disabled={
                    !(procedure.title.length > 0 && procedureSteps.length > 0)
                  }
                  onClick={() => {
                    props.saveOnClick(
                      {
                        procedureType: procedure.type,
                        title: procedure.title,
                        steps: procedureSteps,
                        ...(procedureId ? { documentId: procedureId } : {})
                      },
                      props.navigate
                    );
                  }}
                  className="inherit-parent-width"
                />
              </div>
            )}
          </div>
        )}
      </div>
    </PreviewBar>
  );
}

function ProcedureStep(props) {
  return (
    <div
      data-cy={`PROCEDURE-CARD-${props.data.title.toUpperCase()}`}
      className="inherit-parent-width"
      id={props.procedureStepId}
    >
      {!props.editProcedure ? (
        <>
          <div className="display-flex inherit-parent-width flex-justify-content-space-between">
            <div className="font-color-tertiaryColor">{props.data.title}</div>
            <div
              data-cy={`EDIT-ICON-FOR-${props.data.title.toUpperCase()}`}
              style={{
                height: "20px",
                minHeight: "20px",
                minWidth: "20px"
              }}
              className="cursor-pointer"
              onClick={() => {
                if (!props.disableStepEditButton) {
                  props.editOnClick();
                }
              }}
            >
              <EditIcon height="20" width="20" />
            </div>
          </div>
          <div className="font-size-small padding-top-small font-color-tertiaryColor6">
            {props.data.description}
          </div>
        </>
      ) : (
        <form
          onChange={(event) => {
            props.formOnChange(event);
          }}
        >
          <InputBox
            className="inherit-parent-width "
            name="title"
            label="STEP TO PERFORM"
            placeholder="Enter Step"
            type="text"
            removeResponsive={true}
            autoComplete="off"
            value={props.data.title}
            fontColor="font-color-tertiaryColor"
            labelFontColor="font-color-tertiaryColor"
            data-cy="STEP-FIELD"
            required
          />
          <InputBox
            className="inherit-parent-width padding-top-default "
            name="description"
            label="DESCRIPTION"
            placeholder="Enter Description"
            type="text"
            removeResponsive={true}
            autoComplete="off"
            value={props.data.description}
            fontColor="font-color-tertiaryColor"
            labelFontColor="font-color-tertiaryColor"
            data-cy="DESCRIPTION-FIELD"
            required
          />

          <div className="padding-bottom-medium font-color-tertiaryColor6 font-size-small">
            PROOF REQUIRED
          </div>

          <div className="display-flex ">
            <SelectBox
              value="NO"
              select={!props.data.isProofRequired}
              className="margin-right-medium"
              onClick={() => {
                props.isProofRequiredOnChange(false);
              }}
            />
            <SelectBox
              value="YES"
              select={props.data.isProofRequired}
              onClick={() => {
                props.isProofRequiredOnChange(true);
              }}
            />
          </div>

          <Button
            text="Save"
            data-cy="SAVE-STEP-BUTTON"
            boxShadow={false}
            disabled={props.disableSaveButton}
            onClick={props.saveStepOnClick}
            className="inherit-parent-width margin-bottom-medium margin-top-large"
          />

          <Button
            variant="transparent"
            text="Delete"
            data-cy="CANCEL-STEP-BUTTON"
            boxShadow={false}
            disabled={props.disableDeleteButton}
            onClick={props.deleteStepOnClick}
            className="inherit-parent-width "
            type="button"
          />
        </form>
      )}
    </div>
  );
}

function SelectBox(props) {
  return (
    <div
      data-cy={`${props.value}-SELECT-BOX`}
      className={`inherit-parent-width display-flex padding-large cursor-pointer ${props.className}`}
      style={{
        border: "0.5px solid #6E6E6E",
        backgroundColor: props.select || "rgba(255, 255, 255, 0.08)"
      }}
      onClick={props.onClick}
    >
      {props.select ? (
        <RadioBoxActiveIcon color="var(--secondaryColor)" />
      ) : (
        <RadioBoxInActiveIcon />
      )}
      <div className="padding-left-default font-color-tertiaryColor">
        {props.value}
      </div>
    </div>
  );
}
